import { useEffect, useRef } from 'react';

// documents#188 — the Products tab's poll loop for AI labelling.
//
// While `active` (some product is PENDING), calls `onTick` every `intervalMs`;
// stops the moment `active` turns false or the component unmounts. The first
// tick comes one interval AFTER activation — the list that turned it on was
// just loaded, so there is nothing new to read yet.
//
// `onTick` is read through a ref, so a new closure on every render neither
// restarts the interval nor needs to be memoised by the caller. Kept as its own
// hook (no fetch, no state) so the start/stop rule is unit-testable on its own.
export default function useLabelingPoll({ active, intervalMs, onTick }) {
  const tickRef = useRef(onTick);
  tickRef.current = onTick;

  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(() => {
      if (typeof tickRef.current === 'function') tickRef.current();
    }, intervalMs);
    return () => clearInterval(id);
  }, [active, intervalMs]);
}
